import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/SecurityConfiguration";

export const getDVRTypeList = async () => {
  return axios.get(`${api_base_url}/GetDVRType`).then((res) => {
    return res;
  });
};

export const addDVRType = async (newDVRType) => {
  const { data } = await axios.post(`${api_base_url}/AddDVRType`, {
    ...newDVRType,
  });
  return data;
};

export const deleteDVRType = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}/DeactivateDVRType`, {
    data: ids,
  });
  return data;
};

export const updateDVRType = async (editDVRType) => {
  const { data } = await axios.put(`${api_base_url}/EditDVRType`, editDVRType);
  return data;
};
